import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import { Markdown, Heading, Subtitle, Button } from '../elements';

const Section = styled.section`
  background-color: ${(props) => props.theme.backgroundColorLight};
  .button {
    justify-content: space-between;
  }

  .card:hover {
    background: ${(props) => props.theme.darkShades} !important;
    transition: background 0.7s ease;
  }
  .card:hover .is-hovered {
    color: ${(props) => props.theme.lightShades} !important;
  }

  .card {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .link-wrapper {
    display: block;
    margin-top: auto;
  }
`;

const HowWeHelp = (props) => {
  const { heading, howWeHelp = [] } = props;
  return (
    <Section className="section is-medium">
      <div className="container">
        {heading && (
          <div className="columns is-centered mb-5">
            <div className="column is-8 has-text-centered">
              <Markdown className="pb-2 has-text-grey-dark">{heading}</Markdown>
            </div>
          </div>
        )}

        <div className="columns is-multiline is-variable is-6">
          {howWeHelp &&
            howWeHelp.map((item) => {
              if (!item) return null;
              return (
                <div className="column is-4" key={item._key}>
                  <div className="card is-borderless p-6">
                    <Heading
                      dark
                      className="is-4 has-text-weight-bold is-hovered"
                    >
                      {item.title}
                    </Heading>
                    <Subtitle
                      dark
                      className="subtitle is-6 mb-5 mt-3 is-hovered"
                    >
                      {item.subtitle}
                    </Subtitle>

                    <Link
                      to={item.linkTo ? `/${item.linkTo.current}/` : '#'}
                      className="link-wrapper"
                    >
                      <Button fullWidth className="pt-5 has-text-white">
                        <span>Learn more </span>
                        <span className="icon is-small">
                          <svg
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14.3018 0.247656C14.1522 0.412884 14.0682 0.639887 14.069 0.876728V5.49134C14.069 5.85131 13.8116 6.14314 13.4942 6.14314H0.770097C0.344774 6.14314 0 6.53415 0 7.01651L0 15.9981C0 16.4804 0.344774 16.8714 0.770097 16.8714H13.4942C13.8116 16.8714 14.069 17.1633 14.069 17.5232V22.1509C14.0609 22.6332 14.3991 23.0315 14.8244 23.0406C15.0372 23.0452 15.2423 22.9496 15.3908 22.7766L24.7701 12.1395C24.915 11.9777 24.9977 11.7575 25 11.5268C25.0007 11.2916 24.9179 11.0661 24.7701 10.9011L15.3908 0.264032C15.0941 -0.0815125 14.6065 -0.0888462 14.3018 0.247656Z"
                              fill="white"
                            />
                          </svg>
                        </span>
                      </Button>
                    </Link>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </Section>
  );
};

export default HowWeHelp;
